import React from 'react'
import type { InputProps } from '@chakra-ui/react'
import { withFormControl, type FormFieldProps } from './hoc/withFormControl'
import { BaseDatepicker } from '../Datepicker'

// Component-specific props
export interface DateFormControlComponentProps {
  type?: string
  placeholder?: string
  variant?: InputProps['variant']
  autoComplete?: boolean | string
  maxDate?: Date
  minDate?: Date
}

// Base component that handles date picker logic
export const DateFormControlBase = React.forwardRef<
  HTMLInputElement,
  DateFormControlComponentProps & FormFieldProps<Date | null, HTMLInputElement>
>((props, ref) => {
  const {
    // Form field props
    value,
    onChange,
    onBlur,
    isDisabled,
    // Component-specific props
    variant,
    placeholder,
    autoComplete,
    maxDate,
    minDate
  } = props

  return (
    <BaseDatepicker
      ref={ref}
      date={value ?? undefined}
      onDateChange={(date) => onChange(date ?? null)}
      onBlur={onBlur}
      isDisabled={isDisabled}
      autoComplete={autoComplete === false ? 'off' : 'on'}
      options={{
        maxDate,
        minDate
      }}
      variant={variant}
      placeholder={placeholder}
    />
  )
})

;(DateFormControlBase as any).displayName = 'DateFormControlBase'

// Export the wrapped component
export const DateFormControl = withFormControl<DateFormControlComponentProps, Date | null, HTMLInputElement>(DateFormControlBase)